import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PageHeaderTab} from './page-header-tabs.interface';
import {NgForOf, NgIf, NgStyle} from "@angular/common";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatButtonModule} from "@angular/material/button";
import {MatDivider} from "@angular/material/divider";

@Component({
  selector: 'kit-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  standalone: true,
  imports: [
    NgStyle,
    FlexLayoutModule,
    MatButtonModule,
    MatDivider,
    NgIf,
    NgForOf
  ]
})
export class PageHeaderComponent {
  @Input() banner: boolean = false;
  @Input() fullHeight: boolean = false;
  @Input() section?: string;
  @Input() title!: string;
  @Input() description!: string;
  @Input() subtitle?: string;
  @Input() backgroundWhite: boolean = false;
  @Input() isTabbed?: boolean = false;
  @Input() tabs?: PageHeaderTab[];
  @Output() tabsChangeEvent = new EventEmitter<PageHeaderTab>();
  @Input() selectedTab: PageHeaderTab | null = null;
  @Input() bottomBorder: boolean = false;
  @Input() fullWidthDescription?: boolean = false;

  changeSelectedTab(tab: PageHeaderTab): void {
    this.selectedTab = tab;
    this.tabsChangeEvent.emit(tab);
  }

  isActive(tab: PageHeaderTab): boolean {
    return this.selectedTab?.code === tab.code;
  }
}
